import { DEPENDENCY_ACTIONS } from "components/dashboard/TrainSAM/Dependency/enum";
import { Dropdown } from "components/ui";
import {
    DEPENDENCY_DELETE_PERMISSION,
    DEPENDENCY_UPDATE_PERMISSION,
} from "components/dashboard/TrainSAM/Dependency/permissions";

const SwitchesTableActions = ({
    dependencyName,
    dependencyId,
    dependencyElements,
    handleActionModal,
}) => {
    return (
        <>
            <Dropdown
                size='sm'
                ddValueClass='borderless'
                className='table__dropdown'
                ddOptionsClass='table__dropdown'
                onChange={({ value }) =>
                    handleActionModal(value, {
                        dependencyName,
                        dependencyId,
                        dependencyElements,
                    })
                }
                options={[
                    {
                        value: DEPENDENCY_ACTIONS.EDIT_DEPENDENCY,
                        label: "Edit",
                        baseResources: DEPENDENCY_UPDATE_PERMISSION,
                    },
                    {
                        value: DEPENDENCY_ACTIONS.DELETE_DEPENDENCY,
                        label: "Delete",
                        baseResources: DEPENDENCY_DELETE_PERMISSION,
                    },
                ]}
            />
        </>
    );
};

export default SwitchesTableActions;
